export default __webpack_public_path__ + "static/media/logo_black@2x.f2b9ed84.png";